import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import Sidebar from "../components/layout/Sidebar";
import Header from "../components/layout/Header";
import MembersPage from "../features/members/MembersPage";
import { canManageOrgUsers } from "../utils/roles";
import "../features/account/account.scss";

const Members = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  // Backend enforces admin/org-admin too; this just keeps viewers off the page.
  if (!canManageOrgUsers()) return <Navigate to="/account" replace />;

  return (
    <div className="account-container">
      <Sidebar className={isSidebarOpen ? "open" : ""} />
      {isSidebarOpen && <div className="overlay" onClick={() => setIsSidebarOpen(false)} />}
      <div className="account-content">
        <Header onMenuClick={() => setIsSidebarOpen((p) => !p)} />
        <MembersPage />
      </div>
    </div>
  );
};

export default Members;
